import { Alert } from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Fallback } from '../../../Components/Fallback';
import { ExternalDashboard } from '../../../Domain/Cloudwatch/ExternalDashboard';
import { getDomainIdentifier } from '../../../utils/helpers';
import { LoadGraphs } from './LoadGraphs';
import { getClonedBGMetrics } from './utils';

interface ClonedBGMetricsProps {
  clientId: string;
  domainName: string;
  cellId: string;
  metricRange: any;
  utcOffset: number;
}

const ClonedBGMetrics = (props: ClonedBGMetricsProps) => {
  const [loadGraphs, setLoadGraphs] = useState(false);

  return loadGraphs ? (
    <ErrorBoundary fallbackRender={fallback => <Fallback error={fallback.error} failedComponent={"ClonedBGMetricsDashboard"}/>}>
      <Alert header="Metric Labels:">
        Each graph plots the primary cluster and the clone together. Series prefixed
        "Clone." come from the clone cluster of a Cloned Blue/Green upgrade; they are empty
        when the domain has no clone.
      </Alert>
      <ExternalDashboard
        widgets={getClonedBGMetrics(props.domainName, props.clientId, props.cellId)}
        domainIdentifier={getDomainIdentifier(props.clientId, props.domainName)}
        metricRange={props.metricRange}
        utcOffset={props.utcOffset}
      />
    </ErrorBoundary>
  ) : (
    <LoadGraphs onClick={() => setLoadGraphs(true)} />
  );
};

export { ClonedBGMetrics };
